<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                dialog-model="manufacturer_dialog"
                                perm="companies.create"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetManufacturers(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="manufacturers" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openManufacturerForm(props.item)">
                                <td><img :src="props.item.logo" @error="imageLoadError" style="max-width: 50px; max-height: 50px" /></td>
                                <td>{{ props.item.company }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="manufacturers"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="manufacturer_dialog">
                <v-card>
                    <v-form ref="form_manufacturer">
                        <v-card-title>
                            <span class="headline">{{ manufacturer.company_id ? $t("lang.edit_manufacturer") : $t("lang.add_manufacturer") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeManufacturerDialog"
                                :dialog-status="manufacturer_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="form_manufacturer" @submit.prevent>
                                <v-container grid-list-form>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-focus="manufacturer_dialog"
                                                v-model="manufacturer.company"
                                                :label="`${$t('lang.company')} *`"
                                                :counter="showCounter(manufacturer.company, 'manufacturer.company')"
                                                :rules="ifValid('manufacturer.company')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="manufacturer.company_id" color="error" @mouseup.left="$refs.delete_manufacturers.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeManufacturerDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveManufacturers">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_manufacturers"
                :heading="$t('lang.delete_manufacturer')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteManufacturers(manufacturer.company_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openManufacturerForm" },
                { title: this.$t("lang.refresh"), action: "dbGetManufacturers", params: [true] },
            ],
            headers: [{ text: "", sortable: false, align: "center", width: "60" }, { text: this.$t("lang.manufacturer"), sortable: false }],
            customers: null,
            manufacturer: {},
            filter: {
                search: "",
                company_id: "",
                status: "1",
            },
            manufacturer_dialog: false,
            dbGetManufacturers: _.debounce(this.getManufacturers, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchManufacturers", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.manufacturers) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchManufacturers({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.manufacturers) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.manufacturers.manufacturers_filter,
            page: (state) => state.manufacturers.page,
            rules_manufacturers: (state) => state.manufacturers.rules_manufacturers,
            manufacturer_status_options: (state) => state.settings.manufacturer_status_options,
            manufacturers: (state) => state.manufacturers.manufacturers,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchManufacturers", "saveManufacturer", "deleteManufacturer"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openManufacturerForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "manufacturer", params: { id: item.company_id } });
            } else {
                this.$router.push({ name: "manufacturer" });
            }
        },
        saveManufacturers() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_manufacturer")) {
                    let body = this.prepForm(this.manufacturer, this.rules_manufacturers);

                    this.saveManufacturer({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.$router.push({ name: "manufacturer", params: { id: data.manufacturer.company_id } });
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteManufacturers(id = null) {
            this.deleteManufacturer({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getManufacturers();
                    this.closeManufacturerDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeManufacturerDialog() {
            this.manufacturer_dialog = false;
            this.$refs.delete_manufacturers.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getManufacturers(pg_refresh = false) {
            this.startLoader();

            this.fetchManufacturers({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.manufacturer_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        imageLoadError(event) {
            event.target.src = AppConfig.defaultProfileLogo;
        },
    },
};
</script>
